export const ABROAD_ADMISSION_ROUTES = {
  path: '/services/abroad-admission/',
  title: 'Abroad Admissions',
  links: [
    { label: 'France', path: '/services/abroad-admission/france/', component: 'France' },
    { label: 'Germany', path: '/services/abroad-admission/germany/', component: 'Germany' },
    { label: 'Australia', path: '/services/abroad-admission/australia/', component: 'Australia' },
    { label: 'UK', path: '/services/abroad-admission/uk/', component: 'UK' },
    { label: 'Ireland', path: '/services/abroad-admission/ireland/', component: 'Ireland' },
    { label: 'Russia', path: '/services/abroad-admission/russia/', component: 'Russia' },
  ],
}
